<template>
    <div class="catalog-menu__level2">
        <transition-group tag="ul"
                          @before-enter="$emit('toggle', open);"
                          @after-leave="$emit('toggle', open);"
        >
            <li v-for="(item, idx) in items" v-show="idx < 2 || open" :key="'sc-'+item.id">
                <inertia-link rel="canonical"
                              :preserve-state="true" @click="hideCat()"
                              :only="['category', 'parents', 'products', 'filters', 'seo']"
                              :href="item.url">
                    {{ item.name_short || item.name }}
                </inertia-link>
            </li>
            <li v-if="items.length > 2" :key="'sct-'+catId">
                <a href="#" @click.prevent="toggle()" class="subcat-toggle">{{ open ? 'Приховати' : 'Показати ще' }}</a>
            </li>
        </transition-group>
    </div>
</template>

<script setup>

import {ref, watch} from "vue";
import {hideCat} from "@/frontend/Composables/useHideCat";

const props = defineProps({
    catId: Number,
    items: Array,
    showMore: Boolean,
})

const open = ref(false);
const toggle = () => open.value = !open.value;

watch(() => props.showMore, (value) => open.value = !!value)

</script>

<style scoped>

</style>
